import { Container } from 'inversify';
import { OsiActsPageViewModel } from '@pages/osi/acts';
import { OsiRootViewModel } from '@pages/osi/root/model/viewModel';
import { LoginViewModel, LoginViewModelToken } from '@pages/auth/Login/types';
import { ViewModel as LoginViewModelImpl } from '@pages/auth/Login/model/ViewModel';
import { ShareContactViewModel, ShareContactViewModelToken } from '@pages/auth/Login/ui/ShareContact/types';
import { ViewModel as ShareContactViewModelImpl } from '@pages/auth/Login/ui/ShareContact/model/ViewModel';
import { ResetPasswordViewModelImpl } from '@pages/auth/ResetPassword/model/ResetPasswordViewModelImpl';
import { ResetPasswordViewModel, ResetPasswordViewModelToken } from '@pages/auth/ResetPassword/types';
import { IRegisterPageViewModel, RegisterPageViewModelToken } from '@pages/auth/Register/types';
import { RegistrationWidgetViewModel } from '@pages/auth/Register/model/viewModel';

const pagesContainer = new Container();

BindOsiRoot();
BindOsiActs();
BindLogin();
BindResetPassword();
BindRegistration();

function BindOsiRoot() {
  pagesContainer.bind<OsiRootViewModel>(OsiRootViewModel).toSelf().inTransientScope();
}

function BindOsiActs() {
  pagesContainer.bind<OsiActsPageViewModel>(OsiActsPageViewModel).toSelf().inTransientScope();
}

function BindLogin() {
  pagesContainer.bind<LoginViewModel>(LoginViewModelToken).to(LoginViewModelImpl).inRequestScope();
  pagesContainer
    .bind<ShareContactViewModel>(ShareContactViewModelToken)
    .to(ShareContactViewModelImpl)
    .inTransientScope();
}

function BindResetPassword() {
  pagesContainer
    .bind<ResetPasswordViewModel>(ResetPasswordViewModelToken)
    .to(ResetPasswordViewModelImpl)
    .inRequestScope();
}

function BindRegistration() {
  pagesContainer
    .bind<IRegisterPageViewModel>(RegisterPageViewModelToken)
    .to(RegistrationWidgetViewModel)
    .inRequestScope();
}

export default pagesContainer;
